import { FormInstance } from 'antd/lib'
import {
  GroupManagementForm,
  GroupManagementFormFieldTypes,
} from './group-management-form.tsx'
import { useTranslation } from 'react-i18next'
import IdeyaModal from '../../../../common/antd/ideya-modal.tsx'
import { useGetGroupDetailQuery } from '../../../../apis/firm-management/firm-management-api.api.ts'
import { useEffect } from 'react'
import { IdeyaSpinner } from '../../../../common/components/ideya-spinner.tsx'

interface ActionGroupModalProps {
  showActionModal: boolean
  handleCloseModal: () => void
  form: FormInstance<GroupManagementFormFieldTypes>
  editGroupId?: string | null
  firmId?: string | null
}

export const ActionGroupModal: React.FC<ActionGroupModalProps> = ({
  showActionModal,
  handleCloseModal,
  form,
  editGroupId,
  firmId,
}) => {
  const { t } = useTranslation()

  const {
    currentData: editGroup,
    isLoading: isLoadingEdit,
    isFetching: isFetchingEdit,
  } = useGetGroupDetailQuery(
    { firmId: firmId ?? '', id: editGroupId ?? '' },
    { skip: !editGroupId || !firmId }
  )

  useEffect(() => {
    if (editGroup) {
      form.setFieldsValue({
        name: editGroup.data.name,
        region: editGroup.data.region,
        netCategory: editGroup.data.netCategory,
        firmId: editGroup.data.firmId,
      })
    }
  }, [editGroup, editGroupId, form])

  const handleCloseAndClear = () => {
    handleCloseModal()
    form.resetFields()
  }

  return (
    <IdeyaModal
      open={showActionModal}
      title={
        editGroupId
          ? t('firm_management.group_modal.edit_group')
          : t('firm_management.group_modal.add_group')
      }
      destroyOnHidden
      isForm={true}
      onCancel={handleCloseAndClear}
    >
      {isFetchingEdit || isLoadingEdit ? (
        <IdeyaSpinner />
      ) : (
        <GroupManagementForm
          onCancel={handleCloseAndClear}
          form={form}
          editGroupId={editGroupId}
          mode={editGroupId ? 'edit' : 'create'}
        />
      )}
    </IdeyaModal>
  )
}
